define("ProductLine.Common.Image.Ext", ["ProductLine.Common.Image"], function (
  OriginalImageModule
) {
  "use strict";

  OriginalImageModule.getThumbnail = function getThumbnail() {
    var item = this.get("item");
    var tis = item;
    var objThumb = tis.get("_thumbnail");

    var objThumbNew = {
      url: tis.get("custitemitemimageurl1"),
      altimagetext: "",
    };

    if (tis.get("custitemitemimageurl1")) {
      if (objThumb && objThumb.altimagetext) {
        objThumbNew.altimagetext = objThumb.altimagetext;
      }
      return objThumbNew;
    }

    return objThumb;
  };

  return OriginalImageModule;
});
